import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative bg-gradient-to-br from-yellow-100 via-pink-100 to-purple-100 pt-24 pb-16 px-4 overflow-hidden" data-id="element-67">
      {/* Animated Stars */}
      {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute" style={{
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`
    }} animate={{
      y: [0, -20, 0],
      rotate: [0, 180, 360],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 3 + Math.random() * 2,
      repeat: Infinity,
      delay: Math.random() * 2
    }} data-id="element-68">
          <Sparkles className="text-yellow-400" size={24} data-id="element-69" />
        </motion.div>)}

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-70">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-71">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-72">
            Where Education Meets{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600" data-id="element-73">
              Imagination
            </span>
          </h1>
          <p className="text-xl text-gray-700 mb-8" data-id="element-74">
            We transform school outreach and educational content into magical
            experiences that captivate students, engage parents, and empower
            educators.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-75">
            <button onClick={() => scrollToSection('services')} className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-76">
              Explore Our Services
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold text-lg border-2 border-purple-500 hover:bg-purple-50 transition-all" data-id="element-77">
              Book a Free Call
            </button>
          </div>
        </motion.div>

        {/* Right - Goblin Mascot */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex justify-center" data-id="element-78">
          <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-md" data-id="element-79">
            {/* Body */}
            <ellipse cx="200" cy="280" rx="80" ry="100" fill="#4ADE80" data-id="element-80" />

            {/* Head */}
            <circle cx="200" cy="180" r="90" fill="#4ADE80" data-id="element-81" />

            {/* Wizard Hat */}
            <path d="M 140 140 L 200 40 L 260 140 Z" fill="#8B5CF6" data-id="element-82" />
            <ellipse cx="200" cy="140" rx="70" ry="15" fill="#A78BFA" data-id="element-83" />
            <circle cx="200" cy="50" r="12" fill="#FCD34D" data-id="element-84" />

            {/* Ears */}
            <path d="M 120 160 L 100 140 L 130 150 Z" fill="#4ADE80" data-id="element-85" />
            <path d="M 280 160 L 300 140 L 270 150 Z" fill="#4ADE80" data-id="element-86" />

            {/* Eyes */}
            <ellipse cx="175" cy="170" rx="12" ry="18" fill="#1F2937" data-id="element-87" />
            <ellipse cx="225" cy="170" rx="12" ry="18" fill="#1F2937" data-id="element-88" />
            <circle cx="178" cy="165" r="4" fill="white" data-id="element-89" />
            <circle cx="228" cy="165" r="4" fill="white" data-id="element-90" />

            {/* Smile */}
            <path d="M 170 200 Q 200 215 230 200" stroke="#1F2937" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-91" />

            {/* Book */}
            <rect x="150" y="320" width="60" height="80" rx="5" fill="#EF4444" data-id="element-92" />
            <rect x="155" y="325" width="50" height="70" rx="3" fill="#FEE2E2" data-id="element-93" />
            <line x1="165" y1="340" x2="195" y2="340" stroke="#EF4444" strokeWidth="2" data-id="element-94" />
            <line x1="165" y1="355" x2="195" y2="355" stroke="#EF4444" strokeWidth="2" data-id="element-95" />
            <line x1="165" y1="370" x2="195" y2="370" stroke="#EF4444" strokeWidth="2" data-id="element-96" />

            {/* Star in hand */}
            <motion.g animate={{
            rotate: [0, 360]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'linear'
          }} style={{
            transformOrigin: '270px 340px'
          }} data-id="element-97">
              <path d="M 270 320 L 275 335 L 290 340 L 275 345 L 270 360 L 265 345 L 250 340 L 265 335 Z" fill="#FCD34D" data-id="element-98" />
            </motion.g>

            {/* Arms */}
            <ellipse cx="130" cy="300" rx="25" ry="60" fill="#4ADE80" transform="rotate(-30 130 300)" data-id="element-99" />
            <ellipse cx="270" cy="300" rx="25" ry="60" fill="#4ADE80" transform="rotate(30 270 300)" data-id="element-100" />
          </svg>
        </motion.div>
      </div>
    </section>;
}